import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import './style/main.scss';

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  render: h => h(App),
}).$mount('#app')
